import { ReactElement } from 'react'
import { Translate } from 'src/i18n'
import { MessageBoxTitleBar } from 'src/ui-components/util'
import { MessageBoxType } from 'src/ui-components/util/Interfaces'
import styled from 'styled-components'
import {
  ValidateListError,
  ValidateListErrorCodes,
} from '../../../../../../../../store/lists/interfaces'

interface Props {
  error: ValidateListError
  onClose: () => void
}

const ErrorMessage = (props: Props): ReactElement => {
  const { error, onClose } = props

  const msg =
    error.message !== '' ? error.message : ValidateListErrorCodes.get('DEFAULT')

  const uploadFailedMsg = `${Translate('error')}:`

  return (
    <Wrapper>
      <MessageBoxTitleBar
        titleText={uploadFailedMsg}
        titleSubText={msg}
        type={MessageBoxType.ERROR}
        closeText="dismiss"
        onClose={onClose}
      ></MessageBoxTitleBar>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin: 0px 0px 16px 0px;
`

export default ErrorMessage
